import React, {ReactElement} from 'react';
type ListItemProps = {
  children?: React.ReactNode;
  classes: string;
};
const SizeCard: React.FC<ListItemProps> = (
  props: ListItemProps,
): ReactElement => {
  const {classes, children} = props;
  return <div className={`${classes} container shadow-md`}>{children}</div>;
};
export default SizeCard;
